"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Quote = void 0;
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const quoteStyles = (0, class_variance_authority_1.cva)("relative p-4 bg-brandWhite flex flex-col before:content-[''] before:absolute before:left-0 before:top-[45%] before:h-[70%] before:w-[5px] before:-translate-y-1/2", // Base styles with pseudo-element
{
    variants: {
        color: {
            blue: "bg-blue-500 text-brandWhite",
            yellow: "bg-yellow-100 text-grey900",
            white: "bg-brandWhite text-brandBlack",
        },
        quoteBorderColor: {
            black: "before:bg-brandSecondary",
            blue: "before:bg-blue-500",
            yellow: "before:bg-yellow-500",
            gray: "before:bg-grey300",
            white: "before:bg-brandWhite",
            red: "before:bg-red-500", // Added dynamic red border color
        },
    },
    defaultVariants: {
        color: "white",
        quoteBorderColor: "gray",
    },
});
const Quote = ({ quote, author, color, quoteBorderColor, className = "", role = "blockquote", ariaLabel = "Quote", }) => {
    return (react_1.default.createElement("div", { className: quoteStyles({ color, quoteBorderColor, className }), role: role, "aria-label": ariaLabel },
        react_1.default.createElement("p", { className: "text-grey950 text-[20px] pl-8 italic", role: "text" }, quote),
        author && (react_1.default.createElement("div", { className: "text-grey950 text-[20px] text-right", "aria-label": "Author" },
            "-- ",
            author))));
};
exports.Quote = Quote;
